import React from "react";

// Menu icons
import {
  BarChartOutlined,
  GiftOutlined,
  ShoppingOutlined,
  UserOutlined,
} from "@ant-design/icons";

export const sidebarItems = [
  {
    title: "Cards",
    url: "/",
    icon: <UserOutlined />,
  },
  {
    title: "Coupon",
    url: "/coupons",
    icon: <GiftOutlined />,
  },
  {
    title: "Pacchetti crediti",
    url: "/credit-packs",
    icon: <ShoppingOutlined />,
  },
  {
    title: "Statistiche",
    url: "/stats",
    icon: <BarChartOutlined />,
  },
];
